import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Cell } from '../../base/styled';

import {
  NumberWidget,
  LineChartWidget,
} from '../../widgets';

const Recordings = (props) => {

  const {
    title = '',
    results: {
      error = null,
      data: {
        deadCount = null,
        failedCount = null,
        failedChart = null,
        successCount = null,
        successChart = null,
        progressCount = null,
        progressChart = null,
        failedOverCulledCount = null,
      } = {},
    } = {},
  } = props;

  return (
    <div className="dashboard">
      <h2 style={{ margin: '5px' }}>{title}</h2>
      <Grid columns={6} rows="30% 30% 30%">
        <Cell width={4}>
          <LineChartWidget input={{ error, data: failedChart }} />
        </Cell>
        <Cell width={1}>
          <NumberWidget input={{ error, data: deadCount }} />
        </Cell>
        <Cell width={1}>
          <NumberWidget input={{ error, data: failedCount }} />
        </Cell>
        <Cell width={4}>
          <LineChartWidget input={{ error, data: successChart }} />
        </Cell>
        <Cell width={2}>
          <NumberWidget input={{ error, data: failedOverCulledCount }} />
        </Cell>
        <Cell width={4}>
          <LineChartWidget input={{ error, data: progressChart }} />
        </Cell>
        <Cell width={1}>
          <NumberWidget input={{ error, data: progressCount }} />
        </Cell>
        <Cell width={1}>
          <NumberWidget input={{ error, data: successCount }} />
        </Cell>
      </Grid>
    </div>
  );
};

Recordings.defaultProps = null;

Recordings.propTypes = {
  title: PropTypes.string,
  results: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({
      deadCount: NumberWidget.dataPropType,
      successCount: NumberWidget.dataPropType,
      successChart: LineChartWidget.dataPropType,
      progressCount: NumberWidget.dataPropType,
      progressChart: LineChartWidget.dataPropType,
      failedCount: NumberWidget.dataPropType,
      failedChart: LineChartWidget.dataPropType,
    }),
  }),
};

export default Recordings;
